import React, { Component } from 'react'
import head from '../../images/head1.svg'

export class Card3 extends Component {
    render() {
        const { className, icon } = this.props;
        return (
            <div className={`${className} p-[16px] flex items-center gap-[16px]   bg-[#ffffff] rounded-[8px] shadow-lg max-[650px]:gap-[10px] max-[440px]:p-[10px] max-[390px]:p-[6px] max-[310px]:p-[4px]`}>
                <div className='bg-[#78cbde] w-[70px] h-[70px] rounded-[50px] flex justify-center items-center max-[310px]:w-[60px] max-[310px]:h-[60px]'>
                    {/* <img src={head} className='w-[45px] h-[45px]' /> */}
                    {icon}
                </div>

                <div>
                    {/* <p className='font-[400] text-[18px] text-[#555] max-[650px]:text-[16px] max-[390px]:text-[14px]'>Software</p> */}
                    <h4 className='text-[22px] font-[700] text-[#2e2f46] max-[650px]:text-[19px] max-[440px]:text-[17px] max-[390px]:text-[15px] max-[390px]:font-[600]'>{this.props.title}</h4>
                </div>
            </div>
        )
    }
}

export default Card3